const ArtCardTarget = `
    <svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <defs>
            <path d="M50 0v50H0V0h50Z" id="2ab8di722a"/>
            <path id="ghfbqu7czb" d="M0 0h50v50H0z"/>
        </defs>
        <g fill="none">
            <mask id="5h7z7vbhrc" fill="#fff">
                <use xlink:href="#ghfbqu7czb"/>
            </mask>
            <g fill-rule="evenodd" mask="url(#5h7z7vbhrc)">
                <g transform="translate(2.857 -.714)" fill-rule="nonzero">
                    <path d="m31.181 5.815-5.374-2.386a19.736 19.736 0 0 0-3.071.23c-5.97.917-9.945 4.352-11.464 5.701-7.12 6.317-8.637 15.093-8.733 19.564-.016.703-.06 4.33 1.283 7.866.376.988 1.089 2.817 2.733 4.62.306.338.578.6.77.776l4.932 2.67" fill="#E1BE71"/>
                    <ellipse fill="#FAE4AE" transform="rotate(-62.44 22.227 25.64)" cx="22.227" cy="25.641" rx="21.766" ry="13.713"/>
                    <ellipse fill="#FEF9F2" transform="rotate(-62.44 22.413 26.037)" cx="22.413" cy="26.037" rx="17.638" ry="10.937"/>
                    <ellipse fill="#FAE4AE" transform="rotate(-64.88 22.695 26.487)" cx="22.695" cy="26.487" rx="13.468" ry="7.613"/>
                    <ellipse fill="#FEF9F2" transform="rotate(-64.49 23.003 26.649)" cx="23.003" cy="26.649" rx="9.082" ry="4.743"/>
                    <ellipse fill="#FAE4AE" transform="rotate(-64.27 22.94 26.514)" cx="22.941" cy="26.514" rx="5.194" ry="2.536"/>
                </g>
            </g>
        </g>
    </svg>
`

export default ArtCardTarget
